import { render, staticRenderFns } from "./rigest.vue?vue&type=template&id=5f4ae8c9&scoped=true&"
import script from "./rigest.vue?vue&type=script&lang=js&"
export * from "./rigest.vue?vue&type=script&lang=js&"
import style0 from "./rigest.vue?vue&type=style&index=0&id=5f4ae8c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4ae8c9",
  null
  
)

export default component.exports